import useAuthStore, { type NavItem } from '~/stores/auth';

/**
 * Check if the user profile has been loaded from the API.
 */
export function isProfileLoadedFromApi(): boolean {
   const authStore = useAuthStore();
   return !authStore.isFetchingUserProfile && authStore.user?.user?.email !== '';
}

/**
 * Find a nav item by key in the nav_items tree (top-level and children).
 */
function findNavItemInTree(navItems: NavItem[], key: string): NavItem | undefined {
   for (const item of navItems) {
      if (item.key === key) {
         return item;
      }
      if (item.children) {
         const child = item.children.find(c => c.key === key);
         if (child) {
            return child;
         }
      }
   }
   return undefined;
}

/**
 * Check if a nav item is accessible based on nav_items tree.
 * Returns '/lms' to redirect, or undefined to allow access.
 */
export function checkNavItemAccess(key: string): string | undefined {
   const authStore = useAuthStore();
   const navItems = authStore?.user?.site_settings?.nav_items ?? [];
   const item = findNavItemInTree(navItems, key);

   if (!item || !item.is_visible) {
      return '/lms';
   }
   return undefined;
}
